import { render, staticRenderFns } from "./Claims.vue?vue&type=template&id=f3ee7d8c&scoped=true&"
import script from "./Claims.vue?vue&type=script&lang=js&"
export * from "./Claims.vue?vue&type=script&lang=js&"
import style0 from "./Claims.vue?vue&type=style&index=0&id=f3ee7d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ee7d8c",
  null
  
)

export default component.exports